import type { RouteObject } from 'react-router-dom';
import { Layout } from './features/shared/components/Layout';
import { NotFoundPage } from './features/shared/pages/NotFoundPage';
import { TopPage } from './features/top/pages/TopPage';
import { ServicesPage } from './features/services/pages/ServicesPage';
import { AboutPage } from './features/about/pages/AboutPage';
import { PrivacyPage } from './features/privacy/pages/PrivacyPage';
import {
  ArticleDetailPage,
  articleDetailLoader,
} from './features/articles/pages/ArticleDetailPage';

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <TopPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    element: <Layout />,
    children: [
      {
        path: 'article/:id',
        element: <ArticleDetailPage />,
        loader: articleDetailLoader,
      },
      {
        id: 'not-found',
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
];
